import {
  GetUserV2CommandInput,
  GetUserV2CommandOutput,
  UserNotFoundException,
} from '@amzn/gbsa-orbit-typescript-client';
import { QueryKey, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { userKeys } from 'src/data/api/orbit-service-ts/user/queries/keys';
import { userService } from 'src/data/api/orbit-service-ts/user/userService';

export const useUserDetailsQuery = <TData = GetUserV2CommandOutput>(
  { businessUnit, programId, userId: userAlias }: Partial<GetUserV2CommandInput>,
  options?: Omit<
    UseQueryOptions<GetUserV2CommandOutput, Error, TData, QueryKey>,
    'queryKey' | 'queryFn'
  >,
) =>
  useQuery({
    ...options,
    queryKey: userKeys.details({ userAlias, programId, businessUnit }),
    enabled: !!userAlias && !!programId && !!businessUnit,
    queryFn: async () => {
      if (!userAlias || !programId || !businessUnit) {
        throw new Error('Missing required parameters');
      }
      try {
        const resp = await userService.getUserById({
          userId: userAlias,
          programId,
          businessUnit,
        });
        return resp;
      } catch (error) {
        console.error('Error getting user details:', error);
        if (error instanceof UserNotFoundException) {
          return {
            $metadata: {},
            userDetails: {
              userMetadata: {
                employeeHRStatus: 'A',
                userId: userAlias,
              },
              userPermission: {
                isUserActive: true,
                program: '',
                roleId: '',
                userId: userAlias,
                userName: 'John Doe',
              },
            },
          };
        }
        throw error;
      }
    },
  });
